(()=>{
'use strict';
const root=document.getElementById('kin-fabrics');
if(!root||root.dataset.ready)return;
root.dataset.ready='true';
const library=window.KinFabrics;
if(!library)return;
const fabrics=library.records;
const byId=new Map(fabrics.map(f=>[f.id,f]));

const model=root.querySelector('#kf-model');
const range=root.querySelector('#kf-range'),version=root.querySelector('#kf-version');
const modelControl=root.querySelector('#kf-model-control'),versionControl=root.querySelector('#kf-version-control');
const productOptions=root.querySelector('#kf-product-options');
const config=JSON.parse(root.querySelector('#kf-model-data').textContent),copy=config.copy;
const models=config.models.map(m=>({...m,version:m.range==='mags'?(m.handle.includes('removable-cover')?'mags_removable':m.handle.includes('soft')?(m.handle.includes('low-armrest')?'mags_soft_low':'mags_soft'):(m.handle.includes('low-armrest')?'mags_low':'mags')):m.range==='quilton'?(m.handle.includes('lift')?'quilton_lift':m.handle.includes('combination')?'quilton_modular':'quilton'):'arbour'}));
const incoming=new URLSearchParams(location.search),incomingModel=incoming.get('model');
let incomingVariant=incoming.get('variant');
const comparison=root.querySelector('#kf-comparison');
const status=root.querySelector('#kf-selection-status');
const priceStatus=root.querySelector('#kf-price-status');
const notes=root.querySelector('#kf-notes');
let prices=new Map(),lowest=null,currency=null,request=0,currentProduct=null,optionControls=[],controller=null;
const escape=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const normal=s=>String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'');
const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency,maximumFractionDigits:n%100?2:0}).format(n/100);
const modelName=()=>models.find(m=>m.handle===model.value)?.title||copy.browse;
const selectionName=()=>[modelName(),...optionControls.filter(o=>o.select.value).map(o=>o.select.value)].join(' · ');
const frameValue=()=>optionControls.find(o=>normal(o.name)==='frame')?.select.value||'';
const format=(key,values={})=>Object.entries(values).reduce((text,[key,value])=>text.replaceAll('{'+key+'}',value),copy[key]);
const variantOptions=v=>v.options||[v.option1,v.option2,v.option3];
const productPath=()=>((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/')+'products/'+model.value;
const emit=action=>root.dispatchEvent(new CustomEvent('kin:fabric-guide',{bubbles:true,detail:{action,model:model.value,frame:frameValue()||null,fabrics:library.items().map(f=>({fabric:f.handle,colour:f.code}))}}));
function setAction(link,label){
 const words=document.createElement('span');words.className='kf-action-label';words.textContent=label;
 const arrow=document.createElement('span');arrow.className='kf-arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='→';
 link.replaceChildren(words,arrow);
}
function email(){
 const selected=library.items();
 const body=['Hello kin.,','',"I'd like some help choosing HAY upholstery.",'','Model: '+selectionName(),'Shortlist: '+(selected.length?selected.map(f=>f.name+' · '+(f.colourLabel||'colour to choose')+(f.group?' (group '+f.group+')':'')).join(', '):'Please help me choose'),'','Colours / room / other model: '+notes.value.trim(),'','Please advise on colour availability, appropriate care and samples.','','Guide: https://www.kinstore.co.uk/pages/hay-fabric-options'].join('\n');
 root.querySelector('#kf-email').href='mailto:info@kinstore.co.uk?subject='+encodeURIComponent('HAY fabric advice — '+modelName())+'&body='+encodeURIComponent(body);
}
function render(){
 const selected=library.items();
 root.querySelectorAll('[data-pick]').forEach(input=>{input.checked=selected.some(f=>f.id===input.dataset.pick);input.nextElementSibling.textContent=input.checked?'In your shortlist':'Add to shortlist';});
 root.querySelector('#kf-tray').hidden=selected.length===0;
 root.querySelector('#kf-tray-count').textContent=selected.length+' / 3 samples';
 comparison.innerHTML=selected.length?selected.map(f=>{
  const p=prices.get(f.id);
  const price=p?(p.max!==p.min?copy.from:'')+money(p.min):'';
  const difference=p&&lowest!==null?(p.min===lowest?copy.lowest:format('difference',{price:money(p.min-lowest)})):'';
  const colourLink=f.colourCount?'<a href="'+escape(library.link(f.url))+'" class="kin-colour-link" data-kin-colour-open="'+escape(f.id)+'" data-kin-colour-code="'+escape(f.code)+'"><span>'+ (f.code?'Explore other colours':'Choose a colour')+'</span><span aria-hidden="true">→</span></a>':'';
  return '<article class="kf-comparison-card"><img src="'+escape(f.image)+'" alt="'+escape(f.name+(f.code?' colour '+f.colourLabel:' representative swatch'))+'" width="180" height="180" loading="lazy"><p class="kf-eyebrow">'+(f.group?'HAY group '+f.group:'Special fabrics')+'</p><h3>'+escape(f.name)+'</h3><p class="kin-selected-colour">'+escape(f.code?'Colour '+f.colourLabel:'Colour to choose')+'</p><p class="kf-character">'+escape(f.note)+'</p><p class="kf-small">'+escape(f.material)+'</p><dl>'+(p?'<dt data-sample-price>'+escape(selectionName())+'</dt><dd>'+escape(price)+(difference?'<br><small>'+escape(difference)+'</small>':'')+'</dd>':'')+[['Composition',f.composition],['Abrasion',f.abrasion],['Lightfastness',f.light],['Pilling',f.pilling]].filter(([,value])=>value).map(([label,value])=>'<dt>'+escape(label)+'</dt><dd>'+escape(value)+'</dd>').join('')+'</dl>'+colourLink+'<button type="button" data-remove="'+escape(f.selectionId)+'" aria-label="Remove '+escape(f.name+' '+f.colourLabel)+' from shortlist">Remove from shortlist</button></article>';
 }).join(''):'<p class="kf-empty">Choose up to three samples. Compare different fabrics, or three colours of the same fabric.</p>';
 email();
 root.dispatchEvent(new CustomEvent('kin:fabric-render'));
}
let activeGroup=['all','0','1','2','3','4','5'].includes(incoming.get('fabric_group'))?incoming.get('fabric_group'):'all';
root.querySelector('#kf-fabric-search').value=incoming.get('fabric_search')||'';
function filter(group=activeGroup){
 activeGroup=group;
 const query=(root.querySelector('#kf-fabric-search')?.value||'').toLowerCase().trim();
 root.querySelectorAll('[data-fabric]').forEach(el=>el.hidden=(group!=='all'&&el.dataset.group!==group)||(query&&!el.dataset.search.toLowerCase().includes(query)));
 root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===group)));
 const count=[...root.querySelectorAll('[data-fabric]')].filter(el=>!el.hidden).length;
 status.textContent=count+' fabric'+(count===1?'':'s')+' shown. '+library.items().length+' of 3 samples selected.';
 window.KinFabricJourney?.setBrowse({fabric_search:root.querySelector('#kf-fabric-search').value,fabric_group:group==='all'?'':group});
}
root.querySelector('#kf-fabric-search')?.addEventListener('input',()=>filter());
root.querySelector('#kf-fabric-reset')?.addEventListener('click',()=>{root.querySelector('#kf-fabric-search').value='';filter('all');});
root.querySelectorAll('.kf-controls,.kf-pick').forEach(el=>el.hidden=false);
for(const f of fabrics.filter(f=>f.colourCount)){
 const pick=root.querySelector('[data-pick="'+f.id+'"]')?.closest('.kf-pick');
 if(!pick)continue;
 const link=document.createElement('a');link.className='kin-colour-link';link.href=library.link(f.url);link.dataset.kinColourOpen=f.id;
 link.setAttribute('aria-label','Compare '+f.colourCount+' '+f.name+' colours and choose samples');
 link.innerHTML='<span>Compare '+f.colourCount+' colours</span><span aria-hidden="true">→</span>';
 const shopLink=pick.closest('.kf-card')?.querySelector('[data-sofa-link]');
 if(shopLink){shopLink.before(link);pick.remove();}else pick.replaceWith(link);
}
root.addEventListener('change',e=>{
 if(e.target.matches('[data-pick]')){
  const id=e.target.dataset.pick;
  if(e.target.checked&&library.ensureFabric(id)==='full'){e.target.checked=false;status.textContent='Your shortlist has three samples. Remove one to add another.';return;}
  if(!e.target.checked)library.removeFabric(id);
  status.textContent=library.items().length+' of 3 samples selected. Your comparison is ready below.';emit('shortlist_change');
 }
});
root.addEventListener('click',e=>{
 const filterButton=e.target.closest('[data-filter]');if(filterButton)filter(filterButton.dataset.filter);
 const jump=e.target.closest('[data-jump-group]');if(jump)filter(jump.dataset.jumpGroup);
 const remove=e.target.closest('[data-remove]');if(remove){const id=remove.dataset.remove;library.remove(id);status.textContent=library.items().length+' of 3 samples selected.';const remaining=root.querySelector('[data-remove]');if(remaining)remaining.focus();else root.querySelector('#kin-sample-heading').focus();emit('shortlist_change');}
 if(e.target.closest('#kf-clear')){library.clear();status.textContent='Your shortlist has been cleared.';root.querySelector('[data-fabric-explore], [data-kin-colour-open], [data-pick]').focus();emit('shortlist_clear');}
 const swatch=e.target.closest('[data-loft-filter]');
 if(swatch){
  const colour=swatch.dataset.loftFilter;
  const matched=[...root.querySelectorAll('[data-loft-colour]')].filter(x=>x.dataset.loftColour===colour);
  root.querySelectorAll('[data-loft-colour]').forEach(x=>x.hidden=matched.length>0&&x.dataset.loftColour!==colour);
  root.querySelectorAll('[data-loft-filter]').forEach(x=>x.setAttribute('aria-current',String(x===swatch)));
  root.querySelector('#kf-gallery-status').textContent=matched.length?'Loft '+colour+' on HAY furniture':'Loft '+colour+' shown in the swatch above. Explore the other colours on furniture below.';
  root.querySelector('#kf-loft-reset').hidden=false;
 }
 if(e.target.closest('#kf-loft-reset')){root.querySelectorAll('[data-loft-colour]').forEach(x=>x.hidden=false);root.querySelectorAll('[data-loft-filter]').forEach(x=>x.removeAttribute('aria-current'));root.querySelector('#kf-gallery-status').textContent='Loft on HAY furniture';root.querySelector('#kf-loft-reset').hidden=true;root.querySelector('[data-loft-filter]').focus();}
 if(e.target.closest('#kf-email'))emit('enquiry_email_open');
});
notes.addEventListener('input',email);
function hidePrices(){
 root.querySelectorAll('[data-price],[data-sofa-link]').forEach(el=>{el.hidden=true;});
}
function syncContext(keepOptions=false){
 const url=new URL(location.href);
 if(model.value)url.searchParams.set('model',model.value);else url.searchParams.delete('model');
 url.searchParams.delete('variant');
 if(keepOptions&&currentProduct&&optionControls.some(o=>o.select.value)){
  const candidates=currentProduct.variants.filter(v=>v.available&&optionControls.every(o=>!o.select.value||variantOptions(v)[o.index]===o.select.value));
  const firstFabric=library.items()[0];
  const fabricIndex=currentProduct.options.findIndex(o=>/^(fabric|upholstery)/.test(normal(typeof o==='string'?o:o.name)));
  const selected=candidates.find(v=>firstFabric&&[normal(firstFabric.variant),normal(firstFabric.name)].includes(normal(variantOptions(v)[fabricIndex])))||candidates[0];
  if(selected)url.searchParams.set('variant',selected.id);
 }
 history.replaceState(null,'',url);
 window.KinFabricJourney?.refresh();
 root.querySelectorAll('[data-kin-colour-open], [data-fabric-explore]').forEach(link=>{
  const target=new URL(link.href,location.origin);target.searchParams.delete('model');target.searchParams.delete('variant');
  link.href=window.KinFabricJourney?window.KinFabricJourney.link(target.href,link.closest('[data-fabric-card]')):library.link(target.href);
 });
 const returnField=document.querySelector('#KinFabricSamples [name="return_to"]');
 if(returnField&&window.KinFabricJourney)returnField.value=window.KinFabricJourney.formReturn();
}
function showPrices(){
 if(!currentProduct)return;
 prices=new Map();lowest=null;
 const fabricIndex=currentProduct.options.findIndex(o=>/^(fabric|upholstery)/.test(normal(typeof o==='string'?o:o.name)));
 const variants=currentProduct.variants.filter(v=>optionControls.every(o=>!o.select.value||variantOptions(v)[o.index]===o.select.value));
 for(const f of fabrics){
  const aliases=[f.variant,f.name].filter(Boolean).map(normal);
  const matching=fabricIndex<0?[]:variants.filter(v=>v.available&&aliases.includes(normal(variantOptions(v)[fabricIndex]))&&Number.isFinite(v.price)&&v.price>0);
  if(matching.length){const sorted=matching.slice().sort((a,b)=>a.price-b.price);prices.set(f.id,{min:sorted[0].price,max:sorted[sorted.length-1].price,id:sorted[0].id});}
 }
 lowest=prices.size?Math.min(...[...prices.values()].map(p=>p.min)):null;
 root.querySelectorAll('[data-price]').forEach(el=>{const p=prices.get(el.dataset.price);el.hidden=!p;el.textContent=p?(p.max!==p.min?copy.from:'')+money(p.min):'';});
 root.querySelectorAll('[data-sofa-link]').forEach(el=>{
  const p=prices.get(el.dataset.sofaLink),fabric=byId.get(el.dataset.sofaLink);el.hidden=!p;
  if(!p)return;
  el.href=productPath()+'?variant='+p.id;setAction(el,format('shop',{model:modelName()}));
  el.setAttribute('aria-label',modelName()+' · '+fabric.name);
 });
 priceStatus.textContent=prices.size?format('live_note',{model:selectionName(),currency})+([...prices.values()].some(p=>p.min!==p.max)?' '+copy.from_note:''):copy.no_matches;
 render();
}
function configureOptions(product){
 optionControls=[];productOptions.replaceChildren();
 (product.options||[]).forEach((option,index)=>{
  const name=typeof option==='string'?option:option.name;
  if(/^(fabric|upholstery)/.test(normal(name)))return;
  const values=[...new Set(product.variants.map(v=>variantOptions(v)[index]).filter(Boolean))];
  if(values.length<2)return;
  const wrap=document.createElement('div');wrap.className='kf-model';
  const label=document.createElement('label'),select=document.createElement('select');
  select.id=normal(name)==='frame'?'kf-frame':'kf-option-'+index;label.htmlFor=select.id;label.textContent=name;
  select.setAttribute('aria-describedby','kf-price-status');select.add(new Option(copy.all_options,''));
  values.forEach(value=>select.add(new Option(value,value)));
  select.addEventListener('change',()=>{syncContext(true);showPrices();emit('option_change');});
  wrap.append(label,select);productOptions.append(wrap);optionControls.push({name,index,select});
 });
 productOptions.hidden=!optionControls.length;
}
async function loadPrices(){
 const currentRequest=++request;
 controller?.abort();controller=null;
 prices=new Map();lowest=null;currentProduct=null;optionControls=[];
 productOptions.replaceChildren();productOptions.hidden=true;hidePrices();
 if(!model.value){priceStatus.textContent=range.value?copy.choose_note:copy.browse_note;render();return;}
 const path=productPath(),rootPath=window.Shopify?.routes?.root||'/';
 priceStatus.textContent=copy.loading;render();
 const activeController=new AbortController();controller=activeController;
 const timer=setTimeout(()=>activeController.abort(),12000);
 try{
  const [product,cart]=await Promise.all([fetch(path+'.js',{signal:activeController.signal}).then(r=>{if(!r.ok)throw new Error('Product unavailable');return r.json();}),fetch(rootPath+'cart.js',{signal:activeController.signal}).then(r=>{if(!r.ok)throw new Error('Currency unavailable');return r.json();})]);
  if(currentRequest!==request)return;
  if(!Array.isArray(product.variants)||!Array.isArray(product.options)||!cart.currency)throw new Error('Incomplete data');
  currency=cart.currency;currentProduct=product;configureOptions(product);
  if(incomingVariant){
   const selectedVariant=product.variants.find(v=>String(v.id)===incomingVariant);
   if(selectedVariant){
    optionControls.forEach(o=>{o.select.value=variantOptions(selectedVariant)[o.index]||'';});
    const fabric=fabrics.find(f=>variantOptions(selectedVariant).some(o=>[normal(f.variant),normal(f.name)].includes(normal(o))));
    if(fabric&&!library.items().length)library.ensureFabric(fabric.id);
   }
   incomingVariant=null;
  }
  showPrices();
 }catch(error){
  if(currentRequest!==request)return;
  prices=new Map();lowest=null;currentProduct=null;optionControls=[];
  productOptions.replaceChildren();productOptions.hidden=true;hidePrices();
  priceStatus.textContent=copy.unavailable;render();
 }finally{clearTimeout(timer);}
}
function populateModels(handle=''){
 model.replaceChildren(new Option(copy.choose_model,''));
 const choices=models.filter(m=>m.range===range.value&&m.version===version.value).sort((a,b)=>a.title.localeCompare(b.title,undefined,{numeric:true}));
 choices.forEach(m=>{
  let title=m.title.replace(/^Mags(?: Soft)?\s*(?:-\s*)?(?:Low Armrest\s*)?(?:w[./]? Removable Cover\s*)?(?:-\s*)?/i,'').replace(/ w\. Removable Cover$/i,'').replace(/^Quilton (Lift )?/i,'').replace(/^Arbour /i,'');
  model.add(new Option(title,m.handle));
 });
 modelControl.hidden=!choices.length;
 if(choices.some(m=>m.handle===handle))model.value=handle;
}
function populateVersions(selected=''){
 const versions=[...new Set(models.filter(m=>m.range===range.value).map(m=>m.version))];
 const order=['mags','mags_low','mags_soft','mags_soft_low','mags_removable','quilton','quilton_modular','quilton_lift','arbour'];
 versions.sort((a,b)=>order.indexOf(a)-order.indexOf(b));
 version.replaceChildren(new Option(copy.choose_version,''));
 versions.forEach(key=>version.add(new Option(copy[key],key)));
 versionControl.hidden=versions.length<2;
 version.value=versions.includes(selected)?selected:versions.length===1?versions[0]:'';
 populateModels();
}
['mags','quilton','arbour'].filter(key=>models.some(m=>m.range===key)).forEach(key=>range.add(new Option(copy[key],key)));
const initial=models.find(m=>m.handle===incomingModel);
if(initial){range.value=initial.range;populateVersions(initial.version);populateModels(initial.handle);}
range.addEventListener('change',()=>{populateVersions();model.dispatchEvent(new Event('change',{bubbles:true}));});
version.addEventListener('change',()=>{populateModels();model.dispatchEvent(new Event('change',{bubbles:true}));});
model.addEventListener('change',()=>{incomingVariant=null;syncContext();loadPrices();emit('model_change');});
root.kinFabricGuide={
 fabrics,
 selection:library.items,
 context:()=>({model:model.value,name:selectionName(),frame:frameValue()}),
 setSelection:ids=>{if(!library.items().length)ids.slice(0,3).forEach(id=>library.ensureFabric(id));},
 refresh:render
};
document.addEventListener('kin:shortlist-change',render);
library.ready.then(()=>{render();filter();loadPrices();if(library.restoreMessage)status.textContent=library.restoreMessage;});
})();

